// extracted by mini-css-extract-plugin
var _1 = "ChatRoom-module_left_message__MqC3fQ";
var _2 = "ChatRoom-module_message_date__F5HadN";
var _3 = "ChatRoom-module_right_message__THyNuN";
export { _1 as "left_message", _2 as "message_date", _3 as "right_message" }
